// extracted by mini-css-extract-plugin
export default {"container":"container--mkRfx","title":"title--HbNJr"};